// src/Components/AdminComponents/UploadImageComps/AlbumImageUpload.tsx
import * as React from "react";
import { styled } from "@mui/material/styles";
import { Grid, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AlbumImageList from "./AlbumImageList";

export type PreviewImage = {
    url: string;
    name: string;
    file: File;
    imagedesc: string;
};

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});

type Props = {
    albumId: string; // REQUIRED so uploads can work
    title?: string;
    description?: string;
    category?: string;
    uploadedBy?: string;
    coverImage?: string;
};

export default function AlbumImageUpload({
                                            albumId,
                                        }: Props) {
    const [images, setImages] = React.useState<PreviewImage[]>([]);

    const handleFiles = (fileList: FileList | null) => {
        if (!fileList) return;
        const previews = Array.from(fileList).map((f) => ({
            url: URL.createObjectURL(f),
            name: f.name,
            file: f,
            imagedesc: "",
        }));
        setImages((prev) => [...prev, ...previews]);
    };

    // Cleanup on unmount
    React.useEffect(() => {
        return () => {
            images.forEach((img) => URL.revokeObjectURL(img.url));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleUploaded = (uploadedUrl: string) => {
        setImages((prev) => {
            const t = prev.find((i) => i.url === uploadedUrl);
            if (t) URL.revokeObjectURL(t.url);
            return prev.filter((i) => i.url !== uploadedUrl);
        });
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid sx={{lg:6, md:6, sm:12}}>
                    <Button
                        component="label"
                        variant="contained"
                        startIcon={<CloudUploadIcon />}
                    >
                        Upload files
                        <VisuallyHiddenInput
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={(e) => handleFiles(e.target.files)}
                        />
                    </Button>
                </Grid>

                <Grid sx={{lg:6, md:6, sm:12}} >
                    {/* Image list component expects images + albumId */}
                    <AlbumImageList
                        images={images}
                        albumId={albumId}
                        onUploaded={handleUploaded}
                        onError={(msg) => console.error(msg)}
                    />
                </Grid>
            </Grid>
        </div>
    );
}